export function initSelect2() {
  if (typeof TomSelect === 'undefined') return;

  document.querySelectorAll('[data-select2]').forEach(el => {
    if (el.tomselect) return;

    const hasTemplate = el.hasAttribute('data-select2-template');
    const allowClear = el.hasAttribute('data-select2-clear');

    const config = {
      allowEmptyOption: allowClear,
      placeholder: el.dataset.placeholder || '',
      hidePlaceholder: true,
      dropdownParent: 'body',
    };

    if (hasTemplate) {
      config.render = {
        option: function (data, escape) {
          return renderOption(data, escape);
        },
        item: function (data, escape) {
          return renderSelection(data, escape);
        },
      };
    }

    new TomSelect(el, config);
  });
}

function renderOption(data, escape) {
  const flag = data.flag;
  const icon = data.icon;

  if (flag) {
    return '<div class="ts-option-row"><span class="fi fi-' + escape(flag) + ' fis ts-flag"></span><span>' + escape(data.text) + '</span></div>';
  }
  if (icon) {
    return '<div class="ts-option-row"><i class="' + escape(icon) + ' ts-icon"></i><span>' + escape(data.text) + '</span></div>';
  }
  return '<div>' + escape(data.text) + '</div>';
}

function renderSelection(data, escape) {
  const flag = data.flag;
  const icon = data.icon;

  if (flag) {
    var code = data.value || data.text;
    return '<div class="ts-option-row"><span class="fi fi-' + escape(flag) + ' fis ts-flag"></span><span>' + escape(code) + '</span></div>';
  }
  if (icon) {
    return '<div class="ts-option-row"><i class="' + escape(icon) + ' ts-icon"></i><span>' + escape(data.text) + '</span></div>';
  }
  return '<div>' + escape(data.text) + '</div>';
}
